import React from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Loader2, Search } from "lucide-react";

interface StrategicInitiativeSearchBarProps {
  onInput: (query: string) => void;
  isLoading: boolean;
  className?: string;
  suggestions?: string[];
  placeholder?: string;
}

const StrategicInitiativeSearchBar: React.FC<
  StrategicInitiativeSearchBarProps
> = ({ onInput, isLoading, className, placeholder }) => {
  const handleInput = (e: React.FormEvent<HTMLInputElement>) =>
    onInput(e.currentTarget.value);

  return (
    <div className="relative w-[300px]">
      <form
        className={`w-full flex items-center bg-white border-gray-300 rounded-lg overflow-hidden h-12 ${
          className || ""
        } border`}
      >
        <div className="flex items-center w-full h-full bg-white">
          <Input
            className="flex-grow text-base px-6 h-full flex items-center border-none focus:ring-0 bg-transparent"
            placeholder={placeholder || "Search strategic initiative?"}
            onInput={handleInput}
          />
          <Button
            type="button"
            className="rounded-full bg-transparent text-sky-500 hover:bg-transparent p-2 aspect-square h-10 w-10 mr-2"
            disabled={isLoading}
          >
            {isLoading ? (
              <Loader2 className="h-5 w-5 animate-spin" />
            ) : (
              <Search className="h-5 w-5" />
            )}
          </Button>
        </div>
      </form>
    </div>
  );
};

export default StrategicInitiativeSearchBar;
